import React from "react";

import { ShowCardContainer, ShowCardBottomBar } from "./ShowCard.styles";
import { ImageBox, MeshGradient, MeshColours, ShowDetails } from "..";
import { SelectButton } from "..";
import { Show } from "src/models/audience/Show";

export interface CustomShowCardProps {
  show: Show;
  handleClick: Function,
  colour: MeshColours
}

export const ShowCard = ({
  show,
  handleClick,
  colour = "pink-blue-teal",
  ...rest
}: CustomShowCardProps) => {
  const [isSelected, setIsSelected] = React.useState<boolean>(false);
  return (
    <ShowCardContainer data-cy="show-card" data-id={show.id} onClick={() => { if (handleClick) handleClick(); setIsSelected(!isSelected) }} {...rest}>
      <ImageBox
          src={show.imageUrl}
          alt={`${show.name} Image`}
          variant="sessionCard"
        />
      <ShowDetails show={show}/>
      <ShowCardBottomBar>
        <SelectButton/>
      </ShowCardBottomBar>
      <MeshGradient colour={colour} intensity="high" position="bottom" size="low" sx={{zIndex: 0}}/>
    </ShowCardContainer>
  );
};

export interface ShowCardProps
  extends React.ComponentProps<typeof ShowCard> {
  as?: React.ElementType;
}

ShowCard.displayName = "ShowCard";
